import React, { useMemo } from 'react';
import { Modal, Text, Button, ButtonGroup, Stack } from '@chaser/components';
import useModal from '../../../hooks/useModal';
import useOrganisation from '../../../hooks/useOrganisation';
import { Integrations } from '../../../util/constants';
import IntegrationList from '../../../app/connect/components/IntegrationList';
import ConnectButton from '../../../app/connect/components/ConnectButton';
import FeatureGateCTA from '../FeatureGateCTA';
import cx from 'classnames';
import { FeatureProvider } from '../featureContext';

import style from './DemoGate.module.scss';

function DemoConnectModal({ open, close, onClosed }) {
  const [accountingSoftware, setAccountingSoftware] = React.useState();

  return (
    <Modal open={open} toggle={close} onClosed={onClosed} title="Connect your accounting system">
      <Modal.Body>
        <Stack gap="medium">
          <Text>
            Your demo organisation lets you explore Chasers features without sharing any real data.
            To unlock the full potential of Chaser, create your production account now.
          </Text>
          <IntegrationList
            onIntegrationSelected={setAccountingSoftware}
            selectedIntegration={accountingSoftware}
          />
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button appearance="secondary" onClick={close}>
            Close
          </Button>
          <ConnectButton selectedIntegration={accountingSoftware} />
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}

function DemoGate({
  children,
  type = 'replace',
  text = 'Connect to take advantage of this feature',
  buttonText = 'Connect',
  bt = '50%',
  ...props
}) {
  const showModal = useModal();
  const { accountingSoftware, sandbox } = useOrganisation();

  const ctx = useMemo(
    () => ({
      onUpgrade: () => {
        showModal(<DemoConnectModal />);
      },
      sandbox,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showModal],
  );

  if (accountingSoftware === Integrations.OPENAPI && sandbox) {
    if (type === 'cta')
      return (
        <FeatureProvider value={ctx}>
          <div className={cx(style.wrapper)}>
            <FeatureGateCTA
              text={text}
              buttonText={buttonText}
              style={{ top: bt }}
              className={style.cta}
            />
            <div className={style.content}>
              {typeof children === 'function' ? children(ctx) : children}
            </div>
            <div className={style.overlay}></div>
          </div>
        </FeatureProvider>
      );

    return React.cloneElement(children, { onClick: () => showModal(<DemoConnectModal />) });
  }

  return React.cloneElement(children, props);
}

export default DemoGate;
export { DemoConnectModal };
